// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './filters';
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'lib-flexible'
import moment from 'moment';
import zhLocale from '@/common/lang/zh-CN';
import zh from '@/common/lang/zh';
import store from './store';

// 重置样式
import './css/variable.less';
import './css/common.less';
import './css/mint-reset.less';

//通用组件
import '@/util/globalComponents';

import permission from './libs/permission';
Vue.use(permission);

// 国际化插件
import VueI18n from 'vue-i18n';

// 使用国际化插件
Vue.use(VueI18n); // 通过插件的形式挂载
const i18n = new VueI18n({
  silentFallbackWarn: true,
  locale: 'zh', // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    zh: {      
      ...zh,
      ...zhLocale
    }, // 中文语言包
  }
});

Vue.config.productionTip = false
Vue.prototype.$moment = moment;

Vue.use(MintUI)

/* eslint-disable no-new */
const VueInstance = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});

window.vm = VueInstance;

export default VueInstance;



// WEBPACK FOOTER //
// ./src/main.js